import { Injectable } from '@angular/core';
import { LastOrderedProductModel } from '@libs/shop/models';
import { ConnectorService } from '@libs/shared/services';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LastOrderedProductsRepositoryService {
  public constructor(
    private readonly connector: ConnectorService,
  ) {
  }

  public getAll(): Observable<LastOrderedProductModel[]> {
    return this.connector.connect('shop', 'lastOrderedProducts');
  }
}
